import { render } from "./SettingsPage.vue?vue&type=template&id=3dfd015a"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src299072838/src/goku/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__